import { render, staticRenderFns } from "./review-list.vue?vue&type=template&id=a0e7a6c8"
import script from "./review-list.vue?vue&type=script&lang=ts"
export * from "./review-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports